<template>
  <div id="app">
    <router-view
      ref="targetFater"
      @withdrawAccount="isPay ? onTrial() : ''"
      @onTrial="onTrial"
    />
    <OnTrialPopup
      :open="showTrial.value"
      @close="continueFun"
      @buyFun="buyFun"
    ></OnTrialPopup>
    <!-- start 微信登录 -->
    <WeChatLogin
      ref="weChatLogin"
      :open="wxOpen"
      @close="((wxOpen = false), (first = false)), closeFun()"
      @wxLoginOk="wxLoginOk"
    ></WeChatLogin>
    <!-- end 微信登录 -->
    <!-- start 支付-->
    <MembersBuy
      :open="membersBuyOpen"
      @close="(membersBuyOpen = false), closeFun()"
      @reloadVipInfo="reloadVipInfo()"
    ></MembersBuy>
    <!-- end 支付-->
  </div>
</template>

<script>
import OnTrialPopup from "@/components/OnTrialPopup.vue";
import WeChatLogin from "@/components/WeChatLogin.vue";
import MembersBuy from "@/components/MembersBuy.vue";
import useLocalStorage from "@/useModules/useLocalStorage";
import { showTrial, changeTrialDialog } from "@/useModules/useTrial/use";
import {
  isTiming,
  startTrialTimer,
  stopTrialTimer,
} from "./useModules/useTrial/use";
import { needStartTrialList } from "@/router/index";
import { instance } from "./useModules/instance";
export default {
  components: {
    OnTrialPopup,
    WeChatLogin,
    MembersBuy,
  },
  data() {
    return {
      // 是否显示，试用弹窗
      showTrial,
      // 是否显示弹窗
      open: false,
      // 时间触发器对象
      timer: null,
      // 微信登录弹窗
      wxOpen: false,
      // 支付弹窗
      membersBuyOpen: false,
      // 是否微信登录
      isWxLogin: false,
      // 是否vip
      isVip: false,
      // 计时数
      timeCount: 0,
      // 付费
      isPay: true,
      // 首次
      first: true,
      viewWidth: 1200,
      viewHeight: 780,
      scale: 1,
    };
  },
  provide() {
    return {
      appScale: this.getScale,
    };
  },
  watch: {
    wxOpen: {
      handler(val) {
        if (val) {
          stopTrialTimer();
        } else if (!this.membersBuyOpen) {
          startTrialTimer({
            minTime: 10,
            path: this.$route.path,
          });
        }
      },
    },
    membersBuyOpen: {
      handler(val) {
        if (val) {
          stopTrialTimer();
        } else if (!this.wxOpen) {
          startTrialTimer({
            minTime: 10,
            path: this.$route.path,
          });
        }
      },
    },
    showTrial: {
      handler(val) {
        if (showTrial.value) {
          this.first = false;
        }
      },
      deep: true,
    },
  },
  created() {
    window.onresize = () => {
      return (() => {
        const width = 1200;
        const height = 780;
        this.viewWidth = document.body.offsetWidth;
        this.viewHeight = document.body.offsetHeight;
        this.scale = Math.min(this.viewWidth / width, this.viewHeight / height);
      })();
    };
    instance.$on("showWxLogin", this.delayWxLogin);
    instance.$on("showMembersBuy", this.buyFun);
    this.$store.dispatch("fetchUserLicense");
    localStorage.setItem("isQuit", true);
    localStorage.setItem("timeCount", 0);
    // 试用
    // this.isPay ? this.delayWxLogin() : "";
    //this.isWhethers();
    try {
      const params = window.location.href
        .split("?")[1]
        .split("#")[0]
        .split("&")
        .map((item) => {
          return [item.split("=")[0], item.split("=")[1]];
        });
      const transport = params.find((item) => item[0] === "transport");
      if (transport) {
        window.localStorage.setItem("transport", transport[1]);
      } else {
        window.localStorage.removeItem("transport");
      }
    } catch (e) {
      window.localStorage.removeItem("transport");
    }
  },
  mounted() {
    const { value: storageId } = useLocalStorage("id", 1);
    setInterval(() => {
      storageId.value = Math.random() * 100;
    }, 2000);
    window.addEventListener("beforeunloadHandler", (e) =>
      this.beforeunloadHandler(e)
    );
  },
  destroyed() {
    window.addEventListener("beforeunloadHandler", (e) =>
      this.beforeunloadHandler(e)
    );
  },
  methods: {
    getScale() {
      return this.scale;
    },
    beforeunloadHandler() {
      localStorage.setItem("timeCount", 0);
      localStorage.setItem("isQuit", true);
    },
    // 购买成功
    reloadVipInfo() {
      this.$refs.targetFater.reloadVipInfo();
      store.dispatch("fetchUserLicense");
      this.isVip = true;
    },
    // 关闭
    closeFun() {
      let that = this;
      setTimeout(() => {
        that.isWhethers();
      }, 1000);
    },
    // 延迟登录
    delayWxLogin() {
      setTimeout(() => {
        let token = localStorage.getItem("token");
        if (!token) {
          this.wxOpen = true;
        } else {
          this.isWhethers();
        }
      }, 0); // 不这么写 微信登录图片第一次加载不出来
    },
    // 立即购买
    buyFun() {
      changeTrialDialog(false);
      let wxUserInfo = localStorage.getItem("wxUserInfo");
      if (wxUserInfo) {
        this.membersBuyOpen = true;
      } else {
        this.wxOpen = true;
      }
    },
    // 微信登录
    wxLoginOk() {
      this.isWxLogin = true;
      this.$refs.targetFater.wxLoginOk();
      if (this.first) {
        this.first = false;
      } else {
        this.isWhether();
      }
    },
    // 继续
    continueFun() {
      changeTrialDialog(false);
      // localStorage.setItem("timeCount", 0);
      // this.onTrial();
    },
    // 试用
    onTrial() {
      // if (this.timer) {
      //   clearTimeout(this.timer);
      // }
      // this.timer = setInterval(() => {
      //   let timeCount = localStorage.getItem("timeCount");
      //   if (!timeCount) {
      //     timeCount = 0;
      //   }
      //   timeCount++;
      //   if (timeCount > 300) {
      //     localStorage.setItem("timeCount", -1);
      //     this.open = true;
      //     if (this.timer) {
      //       clearTimeout(this.timer);
      //     }
      //   } else {
      //     localStorage.setItem("timeCount", timeCount);
      //   }
      // }, 1000);
    },
    // 是否vip
    isWhether() {
      let token = localStorage.getItem("token");
      if (token) {
        let data = {
          token: token,
        };
        this.$http({
          url: "https://api.kuaixunda.cn/api/license",
          method: "get",
          params: data,
        }).then(({ data }) => {
          if (data.code == 0) {
            if (data.data.status != 1) {
              if (this.timer) {
                clearTimeout(this.timer);
              }
              this.membersBuyOpen = true;
              localStorage.setItem("timeCount", 0);
            } else if (data.data.status == 1) {
              this.isVip = true;
              this.$store.commit("setIsVip", true);
              localStorage.setItem("timeCount", 0);
            }
          }
        });
      }
    },
    // 是否vip
    isWhethers() {
      let wxUserInfo = localStorage.getItem("wxUserInfo");
      if (wxUserInfo) {
        this.isWxLogin = true;
      } else {
        this.isWxLogin = false;
      }
      // let timeCount = localStorage.getItem("timeCount");
      // if (
      //   timeCount == -1 &&
      //   !this.membersBuyOpen &&
      //   !this.wxOpen &&
      //   !this.isVip
      // ) {
      //   this.open = true;
      //   return;
      // }
      let token = localStorage.getItem("token");
      if (token) {
        let data = {
          token: token,
        };
        this.$http({
          url: "https://api.kuaixunda.cn/api/license",
          method: "get",
          params: data,
        }).then(({ data }) => {
          if (data.code == 0) {
            if (data.data.status != 1) {
              // 没有计时，并且在计时路径内的，返回到首页
              if (!this.membersBuyOpen && !this.wxOpen) {
                startTrialTimer({
                  minTime: 10,
                  path: this.$route.path,
                });
              }
            } else if (data.data.status == 1) {
              this.$store.commit("setIsVip", true);
              this.isVip = true;
              localStorage.setItem("timeCount", 0);
            }
          }
        });
      } else {
        // 没有计时，并且在计时路径内的，返回到首页
        if (
          !isTiming.value &&
          needStartTrialList.findIndex((item) =>
            this.$route.path.includes(item)
          ) !== -1
        ) {
          this.$router.push({ name: "Home" }).catch(() => {});
        }
      }
    },
  },
};
</script>

<style lang="less">
@import "./assets/font/font.css";
@import "./assets/scss/index.css";
#app {
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

body {
  padding: 0px;
  margin: 0px;
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
  background: #ffffff;
}
html,
body {
  height: 100%;
}

.all-page-style {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .all-page-content {
    flex: 1;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
